import { render, staticRenderFns } from "./profit-statistic.vue?vue&type=template&id=f4793398&scoped=true"
import script from "./profit-statistic.vue?vue&type=script&lang=ts"
export * from "./profit-statistic.vue?vue&type=script&lang=ts"
import style0 from "./profit-statistic.vue?vue&type=style&index=0&id=f4793398&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4793398",
  null
  
)

export default component.exports